import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var colors = function colors(self) {
  return [{
    label: self.$t('588'),
    color: '#494545'
  }, {
    label: self.$t('589'),
    color: '#FF9900'
  }, {
    label: self.$t('590'),
    color: 'red'
  }, {
    label: self.$t('591'),
    color: '#CCC'
  }];
};
export var mapColors = new Map([[1, '#494545'], [2, '#FF9900'], [3, 'red'], [4, '#CCC']]);
export var checkData = function checkData(self) {
  return [{
    label: self.$t('584'),
    prop: 'absence_count'
  }, {
    label: self.$t('458'),
    prop: 'present_count'
  }, {
    label: self.$t('585'),
    prop: 'miss_count'
  }, {
    label: self.$t('464'),
    prop: 'late_count'
  }, {
    label: self.$t('586'),
    prop: 'late_hour'
  }, {
    label: self.$t('466'),
    prop: 'leave_early_count'
  }, {
    label: self.$t('587'),
    prop: 'leave_early_hour'
  }, {
    label: self.$t('1409'),
    prop: 'working_length_hour'
  }];
};